import type {
	OnFileUploadPayload,
	OnKeystrokePayload,
	OnNextPayload,
	OnSelectChoicePayload,
	SubmitPayloadSchema,
	WizardFormConfig,
	WizardFormRef,
} from "@CommonLib/src/frontend/WizardForm/types";
import { WizardForm } from "@CommonLib/src/frontend/WizardForm/WizardForm";
import { useEffect } from "react";
import { useRecordContext } from "react-admin";

interface WizardFormFieldProps {
	sendData: (payload: SubmitPayloadSchema) => Promise<void>;
	formRef?: React.RefObject<WizardFormRef> | undefined;
	onMount?: () => void;
	onKeystroke?: ((payload: OnKeystrokePayload) => void) | undefined;
	onNext?: ((payload: OnNextPayload) => void) | undefined;
	onFileUpload?: ((payload: OnFileUploadPayload) => void) | undefined;
	onSelectChoice?: ((payload: OnSelectChoicePayload) => void) | undefined;
}

export const WizardFormField = (props: WizardFormFieldProps) => {
	const { sendData, formRef, onMount, onKeystroke, onNext, onFileUpload, onSelectChoice } = props;
	const record = useRecordContext();

	useEffect(() => {
		if (onMount) {
			onMount();
		}
	}, [onMount]);

	if (!record) return null;
	// biome-ignore lint/complexity/useLiteralKeys: ignore
	if (!record["config"]) return null;

	return (
		<WizardForm
			//biome-ignore lint/complexity/useLiteralKeys: ignore
			config={record["config"] as WizardFormConfig}
			previewMode={false}
			sendData={sendData}
			formRef={formRef}
			onKeystroke={onKeystroke}
			onNext={onNext}
			onFileUpload={onFileUpload}
			onSelectChoice={onSelectChoice}
		/>
	);
};
